import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ConsultationDialog from "@/components/ConsultationDialog";
import { ConsultationProvider } from "@/context/ConsultationContext";
import { Toaster } from "@/components/ui/sonner";

import HomePage from "@/pages/HomePage";
import CompanyFormationPage from "@/pages/CompanyFormationPage";
import VisaServicesPage from "@/pages/VisaServicesPage";
import BankingPage from "@/pages/BankingPage";
import ResourcesPage from "@/pages/ResourcesPage";

import HomeV2 from "@/pages/v2/HomeV2";
import CompanyFormationV2 from "@/pages/v2/CompanyFormationV2";
import VisaV2 from "@/pages/v2/VisaV2";
import BankingV2 from "@/pages/v2/BankingV2";
import AboutV2 from "@/pages/v2/AboutV2";
import ContactV2 from "@/pages/v2/ContactV2";
import ServicePageV2 from "@/pages/v2/ServicePageV2";
import BlogV2 from "@/pages/v2/BlogV2";
import BlogPostV2 from "@/pages/v2/BlogPostV2";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminPostEditor from "@/pages/admin/AdminPostEditor";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

function V1Layout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App bg-white text-foreground min-h-screen font-body">
      <BrowserRouter>
        <ConsultationProvider>
          <ScrollToTop />
          <Routes>
            {/* V1 Routes (kept under /v1 as draft) */}
            <Route
              path="/v1/*"
              element={
                <V1Layout>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route
                      path="/company-formation/:type"
                      element={<CompanyFormationPage />}
                    />
                    <Route path="/visa-services" element={<VisaServicesPage />} />
                    <Route path="/banking" element={<BankingPage />} />
                    <Route path="/resources" element={<ResourcesPage />} />
                    <Route path="*" element={<HomePage />} />
                  </Routes>
                </V1Layout>
              }
            />

            {/* V2 Routes — primary site at root (each page renders its own HeaderV2 + FooterV2) */}
            <Route path="/" element={<HomeV2 />} />
            <Route path="/company-formation/:type" element={<CompanyFormationV2 />} />
            <Route path="/visa" element={<VisaV2 />} />
            <Route path="/banking" element={<BankingV2 />} />
            <Route path="/services/:slug" element={<ServicePageV2 />} />
            <Route path="/about" element={<AboutV2 />} />
            <Route path="/contact" element={<ContactV2 />} />
            <Route path="/blog" element={<BlogV2 />} />
            <Route path="/blog/:slug" element={<BlogPostV2 />} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/posts/new" element={<AdminPostEditor />} />
            <Route path="/admin/posts/:id/edit" element={<AdminPostEditor />} />

            <Route path="*" element={<HomeV2 />} />
          </Routes>
          <ConsultationDialog />
          <Toaster
            position="top-right"
            toastOptions={{
              classNames: {
                toast:
                  "bg-[#0A1128] border border-white/10 text-white rounded-sm font-body",
                description: "text-slate-300",
              },
            }}
          />
        </ConsultationProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
